const config = {
  environment: 'prod',
  hosts: {
    bucket: 'https://assets.playkidsapp.com/offers',
    offers: 'https://offers.playkidsapp.com',
    app: 'https://app.playkids.com'
  }
}

export default config
